import React, { FC } from 'react';
import { TableFooter, TableRow, TableCell } from '@dxb-web-ui-framework/design-system';

export interface TableGridFooterProps {
  colSpan: number;
}

const TableGridFooter: FC<TableGridFooterProps> = ({ colSpan, children }) => (
  <TableFooter>
    <TableRow>
      <TableCell colSpan={colSpan}>{children}</TableCell>
    </TableRow>
  </TableFooter>
);

export { TableGridFooter };
